// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2m-0";
export var spinnerContainer = "_2m-1";